import Layout from '@@client/app/Layout'
import GeneralPage, {Header, Content, NarrowContent} from '@@client/app/GeneralPage'
import {getServerConfig} from '@@client/config'
import {getFaqsPageContent} from '@@client/content/api'
import Markdown from '@@client/components/Markdown'

const Faq = ({question, children, id = null}) => {
    return (
        <>
            <div className='faq' id={id}>
                <div className='question'>{question}</div>
                <div className='answer'>{children}</div>
            </div>
            <style jsx>
                {`
                    @import '@css/variables.css';

                    .faq {
                        margin-bottom: 30px;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }

                    .question {
                        font-weight: $weight--bold;
                        margin-bottom: 10px;
                    }
                `}
            </style>
        </>
    )
}

export default function Page({title, lead, faqs, failed}) {
    if(failed) return null

    faqs = faqs || []

    return (
        <Layout title={title}>
            <GeneralPage>
                <Header title={title}>
                    <Markdown>{lead}</Markdown>
                </Header>
                <Content>
                    <NarrowContent>
                        {faqs.map(faq => (<Faq key={faq.question} question={faq.question} id={faq.slug || undefined}><Markdown>{faq.answer || ''}</Markdown></Faq>))}
                    </NarrowContent>
                </Content>
            </GeneralPage>
        </Layout>
    )
}

export async function getServerSideProps() {
    const config = getServerConfig()

    const result = await getFaqsPageContent(config.content.apiUrl)

    return {
        props: result.success ? result.entity : {failed: true},
    }
}
